import {
  getAccessTokenInfoFromCookie,
  getErrorAsString,
  getMsaImplicitFlowCredentials,
  IAuthCookie,
  IAuthenticatedUserInfo,
  isTokenExpired,
  refreshAccessToken
} from '@notes/webintegrations-common'
import { getAuthTypeWithExtension } from '../../agave/auth/getAuthTypeWithExtension'
import { Log } from '../logger/Log'
import { StickyNotesExchangeTokenFactory, StickyNotesTokenInfo } from './StickyNotesExchangeToken'

/**
 * Given an authenticated user, gets the app tokens needed for Sticky Notes SDK
 */
export async function getAppTokenInfoForStickyNotes(userInfo: IAuthenticatedUserInfo, forceRefresh: boolean, userInfoToken?: string): Promise<StickyNotesTokenInfo> {
  const exchangeToken = StickyNotesExchangeTokenFactory.create(userInfo, forceRefresh, userInfoToken)
  return await exchangeToken.exchangeTokenForStickyNotesTokens()
}

export async function tryGetOAuthToken(): Promise<IAuthCookie | undefined> {
  const authType = getAuthTypeWithExtension()

  if (!authType) {
    Log.logger.info('User is not authenticated')
    return undefined
  }

  if (authType === 'o365') {
    let tokenInfo = getAccessTokenInfoFromCookie()
    if (!tokenInfo) {
      Log.logger.info('No access token cookie detected. Returning undefined')
      return undefined
    }

    if (isTokenExpired(tokenInfo.expires_in)) {
      try {
        await refreshAccessToken()
      } catch (error) {
        Log.logger.warn(`Error occurred while refreshing access token: ${getErrorAsString(error)}. Returning undefined`)
        return undefined
      }

      tokenInfo = getAccessTokenInfoFromCookie()
      if (!tokenInfo) {
        Log.logger.warn('No access token cookie detected even after refreshing an existing one. Returning undefined')
        return undefined
      }
    }

    return tokenInfo
  }

  if (authType === 'msa_implicit') {
    return getMsaImplicitFlowCredentials()
  }

  Log.logger.warn(`tryGetOAuthTokenWithoutUserAction got unsupported AuthType: ${authType}`)
  return undefined
}
